 let mondialMap, markerLayer, markerMap = new Map();
  let activeCard = null;

  const setVal = (id, val) => {
    const el = document.getElementById(id);
    if (el) el.value = val;
  };

  const addressInput = document.getElementById("full_address_mr");
  const geoLocationButton = document.getElementById("detect-location");

  function showGeoButton() {
    document.getElementById("mr_PointRelais_Geolocation").style.display = "inline-block";
  }

  function hideGeoButton() {
    setTimeout(() => {
      document.getElementById("mr_PointRelais_Geolocation").style.display = "none";
    }, 100);
  }

addressInput.addEventListener("focus", showGeoButton);
addressInput.addEventListener("click", showGeoButton);
addressInput.addEventListener("blur", hideGeoButton);

// Permitir búsqueda con Enter en el input de dirección
addressInput.addEventListener("keydown", (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
    document.getElementById("find-mondial-relay").click();
    addressInput.blur(); // salir del campo de texto
  }
});

  function renderMondialRelayPoints(points) {
    let selectedRelayId = null;

    points.sort((a, b) => a.distance - b.distance);

    // Nueva función formatSchedule agrupada y limpia
    function formatSchedule(h1, h2) {
      const days = { L: "Lundi", Ma: "Mardi", Me: "Mercredi", J: "Jeudi", V: "Vendredi", S: "Samedi", D: "Dimanche" };
      const order = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
      const scheduleMap = {};

      const parse = (str) => {
        if (!str) return;
        const regex = /([LMaeJVS\/D]+)\s+([0-9h:\-–:,]+)/g;
        let match;
        while ((match = regex.exec(str)) !== null) {
          const dayKeys = match[1].split("/").filter(Boolean);
          const time = match[2].replace(/[,;]$/, "").trim();
          dayKeys.forEach((d) => {
            const day = days[d];
            if (day) {
              if (!scheduleMap[day]) scheduleMap[day] = [];
              if (!scheduleMap[day].includes(time)) scheduleMap[day].push(time);
            }
          });
        }
      };

      parse(h1);
      parse(h2);

      const formatted = [];
      let group = [];
      let lastTime = null;

      const flushGroup = () => {
        if (!group.length) return;
        const label = group.length === 1 ? group[0] : `${group[0]} à ${group[group.length - 1]}`;
        // Formatear lastTime en formato 9h - 12h30, etc.
        const formattedTime = lastTime
          ? lastTime
              .split("/")
              .map(slot => {
                const parts = slot.split("-").map(t => t.trim());
                return parts.map(p => {
                  const [h, m] = p.split(":");
                  // Formato francés: 9h30 o 9h
                  return m ? `${h}h${m}` : `${h}h`;
                }).join(" - ");
              })
              .join(" / ")
          : "";
          if (formattedTime && formattedTime.trim() !== "") {
            formatted.push(`<span class="lpb-body-s">${label}: ${formattedTime}</span>`);
          }
        group = [];
      };

      for (const day of order) {
        const currentTime = scheduleMap[day]?.join(" / ") || null;
        if (currentTime === lastTime) {
          group.push(day);
        } else {
          flushGroup();
          if (currentTime) {
            group = [day];
            lastTime = currentTime;
          } else {
            lastTime = null;
          }
        }
      }

      flushGroup();
      return `<div class='relay-card-time'>${formatted.join("")}</div>`;
    }

    const container = document.getElementById("mr_PointRelais_Details");
    container.innerHTML = "";

    if (!points.length) {
      container.innerHTML = "<p>Aucun point relais trouvé.</p>";
      return;
    }

    // Crear wrapper con display flex
    const wrapper = document.createElement("div");
    wrapper.className = "mondial-wrapper";
    container.appendChild(wrapper);

    // Contenedor lista con tarjetas
    const listContainer = document.createElement("div");
    listContainer.id = "mondial-relay-list";
    listContainer.className = "mondial-relay-list";
    wrapper.appendChild(listContainer);

    // Contenedor mapa
    const mapWrapper = document.createElement("div");
    mapWrapper.id = "mondial-map-wrapper";
    mapWrapper.className = "mondial-map-wrapper";
    const mapDiv = document.createElement("div");
    mapDiv.id = "mondial-map";
    mapWrapper.appendChild(mapDiv);
    wrapper.appendChild(mapWrapper);

    // Inicializar mapa
    if (mondialMap) {
      mondialMap.remove();
      markerMap.clear();
    }
    const existingMapDiv = document.getElementById("mondial-map");
    if (existingMapDiv) {
      existingMapDiv.innerHTML = "";
    }

    mondialMap = L.map("mondial-map").setView([46.6, 1.88], 6);
    L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; OpenStreetMap France'
    }).addTo(mondialMap);

    markerLayer = L.layerGroup().addTo(mondialMap);
    const bounds = [];

    points.forEach((p) => {
      const lat = p.latitude ? parseFloat(p.latitude) : null;
      const lng = p.longitude ? parseFloat(p.longitude) : null;
      if (lat !== null && lng !== null && !isNaN(lat) && !isNaN(lng)) {
        const popupHTML = `
          <div class="lpb-body-m">
            <strong class="lpb-body-m-bold">${p.name || "Point relais"}</strong><br>${p.address}<br>${p.zip} ${p.city}<br>
            ${(p.horaires1 || p.horaires2) ? formatSchedule(p.horaires1, p.horaires2) : ""}
          </div>
        `;

        const selectedIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="32" height="32"><path fill="#001e0a" d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>`;

        const unselectedIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="32" height="32"><path class="fa-secondary" opacity="1" fill="#61c680" d="M48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192c0-79.5-64.5-144-144-144S48 112.5 48 192zm224 0a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z"/><path class="fa-primary" fill="#001e0a" d="M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"/></svg>`;

        const customIcon = L.divIcon({
          className: 'custom-relay-icon',
          html: `${p.id === selectedRelayId ? selectedIconSVG : unselectedIconSVG}`,
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -32]
        });

        const marker = L.marker([lat, lng], { icon: customIcon }).bindPopup(popupHTML).addTo(markerLayer);
        markerMap.set(p.id, marker);

        marker.on("click", () => {
          selectedRelayId = p.id;
          if (activeCard) activeCard.classList.remove("selected");
          const targetCard = document.querySelector(`.relay-card[data-relay-num="${p.id}"]`);
          if (targetCard) {
            targetCard.classList.add("selected");
            targetCard.scrollIntoView({ behavior: "smooth", block: "center" });
            activeCard = targetCard;
          }

          setVal("shipping_company", p.name || "Point relais");
          setVal("shipping_street1", p.address);
          setVal("shipping_street2", "");
          setVal("shipping_postcode", p.zip);
          setVal("shipping_city", p.city);
          setVal("shipping_mondialrelay", p.id);

          marker.openPopup();

          // Update icons on all markers to reflect selection
          markerMap.forEach((m, id) => {
            const iconHtml = id === selectedRelayId ? selectedIconSVG : unselectedIconSVG;
            m.setIcon(L.divIcon({
              className: 'custom-relay-icon',
              html: iconHtml,
              iconSize: [32, 32],
              iconAnchor: [16, 32],
              popupAnchor: [0, -32]
            }));
          });
        });

        bounds.push([lat, lng]);

        const card = document.createElement("div");
        card.className = "relay-card";
        card.dataset.relayNum = p.id;
        card.innerHTML = `
          <small class="lpb-label-s" style="text-transform:none;">
            ${p.distance ? (p.distance >= 1000 ? `${(p.distance / 1000).toFixed(1)} km` : `${Math.round(p.distance)} m`) : ""}
          </small>
          <strong class="lpb-body-s-bold">${p.name || "Point relais"}</strong>
          <span class="lpb-body-s relay-card-address">${p.address} <br>${p.zip} ${p.city}</span>
          ${(p.horaires1 || p.horaires2) ? formatSchedule(p.horaires1, p.horaires2) : ""}
        `;
        card.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          selectedRelayId = p.id;
          if (activeCard) activeCard.classList.remove("selected");
          card.classList.add("selected");
          card.scrollIntoView({ behavior: "smooth", block: "center" });
          activeCard = card;

          setVal("shipping_company", p.name || "Point relais");
          setVal("shipping_street1", p.address);
          setVal("shipping_street2", "");
          setVal("shipping_postcode", p.zip);
          setVal("shipping_city", p.city);
          setVal("shipping_mondialrelay", p.id);

          if (!isNaN(lat) && !isNaN(lng)) {
            mondialMap.setView([lat, lng], 15);
            markerLayer.eachLayer((layer) => layer.closePopup());

            const marker = markerMap.get(p.id);
            if (marker) {
              marker.openPopup();
              mondialMap.setView([lat,lng], 15);
            }
          }

          // Update icons on all markers to reflect selection
          markerMap.forEach((m, id) => {
            const iconHtml = id === selectedRelayId ? selectedIconSVG : unselectedIconSVG;
            m.setIcon(L.divIcon({
              className: 'custom-relay-icon',
              html: iconHtml,
              iconSize: [32, 32],
              iconAnchor: [16, 32],
              popupAnchor: [0, -32]
            }));
          });
        });
        listContainer.appendChild(card);
      }
    });

    // Seleccionar la primera tarjeta automáticamente
    const firstCard = listContainer.querySelector(".relay-card");
    if (firstCard) firstCard.click();

    if (bounds.length) {
      mondialMap.setView(bounds[0], 15);
    }
  }

  document.getElementById("find-mondial-relay").addEventListener("click", async (e) => {
    e.preventDefault();
    const address = document.getElementById("full_address_mr").value.trim();
    if (!address) {
      alert("Veuillez saisir une adresse.");
      return;
    }
    
    const container = document.getElementById("mr_PointRelais_Details");
    container.innerHTML = "";

    try {
      const res = await fetch("/apps/lpb/api/mr-address", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ address })
      });

      const raw = await res.text();
      const data = JSON.parse(raw);
      

      if (!data?.success || !data?.data?.length) {
        console.warn("No se encontraron puntos. Respuesta:", data);
        console.log("Adresse introuvable.");
        return;
      }

      const points = data.data;
      renderMondialRelayPoints(points);

    } catch (error) {
      console.error("Error al buscar puntos relais:", error);
      console.log("Une erreur est survenue lors de la recherche des points relais.");
    }
  });

  geoLocationButton.addEventListener("click", () => {
    if (!navigator.geolocation) {
      alert("La géolocalisation n'est pas supportée par votre navigateur.");
      return;
    }

    navigator.geolocation.getCurrentPosition(async (position) => {
      try {
        const res = await fetch("/apps/lpb/api/mr-gps", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          })
        });

        const raw = await res.text();
        const data = JSON.parse(raw);

        if (!data?.success || !data?.data?.length) {
          console.log("Aucun point relais trouvé avec votre position actuelle.");
          return;
        }

        renderMondialRelayPoints(data.data);
      } catch (error) {
        console.error("Erreur lors de la récupération des points par GPS:", error);
        console.log("Erreur lors de la recherche des points relais.");
      }
    }, () => {
      alert("Impossible de détecter la position actuelle.");
    });
  });